import lng from '@lightningjs/core';
import { Utils } from '@lightningjs/sdk';

export default class EditIcon extends lng.Component {
  static _template() {
    return {
      Icon: {},
    };
  }

  set src(val) {
    return (this._src = val);
  }

  get _Icon() {
    return this.tag('Icon');
  }

  _firstEnable() {
    this._Icon.patch({
      w: 65,
      h: 65,
      src: Utils.asset(this._src),
      zIndex: 20,
      y: 190,
      x: 190,
    });
  }
}
